// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lab-bar-chart-container, .lab-line-chart-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
}
.lab-bar-chart-container .chart-wrapper, .lab-line-chart-container .chart-wrapper {
  height: 300px;
  width: 100%;
}
.lab-bar-chart-container .line, .lab-line-chart-container .line {
  height: 371px;
}
.lab-bar-chart-container .custom-legend, .lab-line-chart-container .custom-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 20px;
  justify-content: center;
  max-width: 1000px;
}
.lab-bar-chart-container .custom-legend .legend-item, .lab-line-chart-container .custom-legend .legend-item {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #374151;
}
.lab-bar-chart-container .custom-legend .legend-item .legend-color, .lab-line-chart-container .custom-legend .legend-item .legend-color {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
}
.lab-bar-chart-container .custom-legend .legend-item .legend-label, .lab-line-chart-container .custom-legend .legend-item .legend-label {
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/components/comparison-lab/steps/graphs/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AACF;AACE;EACE,aAAA;EACA,WAAA;AACJ;AAEE;EACE,aAAA;AAAJ;AAGE;EACE,aAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;AADJ;AAGI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AADN;AAGM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AADR;AAIM;EACE,mBAAA;AAFR","sourcesContent":[".lab-bar-chart-container, .lab-line-chart-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  margin-top: 12px;\n\n  .chart-wrapper {\n    height: 300px;\n    width: 100%;\n  }\n\n  .line {\n    height: 371px;\n  }\n\n  .custom-legend {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px 20px;\n    justify-content: center;\n    max-width: 1000px;\n\n    .legend-item {\n      display: flex;\n      align-items: center;\n      gap: 4px;\n      font-size: 12px;\n      color: #374151;\n\n      .legend-color {\n        width: 12px;\n        height: 12px;\n        border-radius: 50%;\n        flex-shrink: 0;\n      }\n\n      .legend-label {\n        white-space: nowrap;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
